
import { Vue, Prop, Component } from 'vue-property-decorator';
import { formatCurrencyByProject } from '@t/format-currency';

@Component({})
export default class PrevisionalBudget extends Vue {
    @Prop() employeeId!: string;
    @Prop() phaseId!: number;
    @Prop() parentPhaseId!: number;
    @Prop() budget!: number | null;
    @Prop() phaseTotalRate!: number | null;
    @Prop() employeeTotalRate!: number
    formatAmountWithCurrency(value: number): string {
        return formatCurrencyByProject(value, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    amountStyle() {
        if (this.parentPhaseId === 0 && this.phaseTotalRate !== null && this.budget !== null) {
            return this.phaseTotalRate <= this.budget ? 'green' : 'red';
        }
        return '';
    }

    displayAmount() {
        if (this.parentPhaseId === 0) {
            return this.phaseTotalRate ? this.formatAmountWithCurrency(this.phaseTotalRate) : '-';
        } else {
            return this.employeeTotalRate ? this.formatAmountWithCurrency(this.employeeTotalRate) : '-';
        }
    }
}
